import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ShareButtons from "../components/ShareButtons";
import { api } from "../lib/api";
import { useLang } from "../lib/lang";
import { ArrowLeft } from "lucide-react";

export default function NewsDetailPage() {
  const { id } = useParams();
  const { tri, t } = useLang();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api
      .get(`/news/${id}`)
      .then((r) => setItem(r.data))
      .catch(() => setItem(null))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="App" data-testid="news-detail-page">
      <Header />
      <article className="max-w-4xl mx-auto px-6 py-16">
        <Link to="/news" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-slate-700 hover:text-red-600 mb-8" data-testid="news-back">
          <ArrowLeft className="w-4 h-4" /> {t("nav_news")}
        </Link>
        {loading ? (
          <div className="py-20 text-slate-500">Loading…</div>
        ) : !item ? (
          <div className="py-20 text-slate-500">{t("no_data")}</div>
        ) : (
          <>
            <div className="text-xs uppercase tracking-[0.3em] text-red-600 font-semibold mb-3" data-testid="news-detail-category">
              {item.category}
            </div>
            <h1 className="font-display text-5xl sm:text-6xl text-slate-900 leading-none mb-6" data-testid="news-detail-title">
              {tri(item.title)}
            </h1>
            <div className="text-sm text-slate-500 mb-8" data-testid="news-detail-date">
              {new Date(item.created_at).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </div>
            {item.image_url && (
              <img src={item.image_url} alt="" className="w-full aspect-video object-cover mb-10" />
            )}
            <p className="text-xl text-slate-700 leading-relaxed mb-6 font-medium" data-testid="news-detail-excerpt">
              {tri(item.excerpt)}
            </p>
            <ShareButtons title={tri(item.title)} url={typeof window !== "undefined" ? window.location.href : ""} />
            <div className="prose prose-slate max-w-none text-slate-800 leading-relaxed whitespace-pre-line" data-testid="news-detail-content">
              {tri(item.content)}
            </div>
          </>
        )}
      </article>
      <Footer />
    </div>
  );
}
